import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';

// components
import { SbSharedPriceTile } from '../SbSharedPriceTile/SbSharedPriceTile';
import { SbRespTilesSwiper } from '../SbRespTilesSwiper/SbRespTilesSwiper';
import { ServerVarsContextConsumer } from '../../global/ServerVarsContext/ServerVarsContext';
import { SbRespTradeFreeShippingPromoTile } from '../SbRespTradeFreeShippingPromoTile/SbRespTradeFreeShippingPromoTile';

import styles from './SbRespPriceTiles.scss';

const MAX_DISPLAY_PRICE_TILES = 4;

function getPriceTilesForCurrency(tiles, currency) {
    return tiles.filter(t => !!t && t.currency === currency);
}

export const SbRespPriceTilesComponent = props => {
    const { searchBrowse, viewer } = props;
    const priceTiles = get(searchBrowse, 'priceTiles') || [];

    if (!priceTiles.length) {
        return null;
    }

    return (
        <ServerVarsContextConsumer>
            {({ isTablet }) => (
                <div className={styles.container}>
                    <SbRespTilesSwiper isTablet={isTablet}>
                        <CurrencyProvider
                            render={({ currency }) => (
                                <React.Fragment>
                                    {getPriceTilesForCurrency(priceTiles, currency)
                                        .slice(0, MAX_DISPLAY_PRICE_TILES)
                                        .map((priceTile, i) => {
                                            const { displayName, image, url } = priceTile;
                                            const indexLabel = i + 1;
                                            return (
                                                <SbSharedPriceTile
                                                    displayName={displayName}
                                                    hoverMessage={
                                                        <FormattedMessage
                                                            id="sb.SbRespPriceTiles.shop"
                                                            defaultMessage="shop"
                                                        />
                                                    }
                                                    image={image}
                                                    isPriceBucket
                                                    key={`priceTile-${displayName}`}
                                                    position={indexLabel}
                                                    promoLabel={`Trade Price Range ${indexLabel}`}
                                                    searchBrowse={searchBrowse}
                                                    url={url}
                                                />
                                            );
                                        })}
                                    <SbRespTradeFreeShippingPromoTile
                                        currency={currency}
                                        position={5}
                                        searchBrowse={searchBrowse}
                                        viewer={viewer}
                                    />
                                </React.Fragment>
                            )}
                        />
                    </SbRespTilesSwiper>
                </div>
            )}
        </ServerVarsContextConsumer>
    );
};

SbRespPriceTilesComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
    viewer: PropTypes.object,
};

export const SbRespPriceTiles = createFragmentContainer(SbRespPriceTilesComponent, {
    searchBrowse: graphql`
        fragment SbRespPriceTiles_searchBrowse on SearchBrowseQueryConnection {
            ...SbSharedPriceTile_searchBrowse
            ...SbRespTradeFreeShippingPromoTile_searchBrowse
            displayUriRef
            priceTiles(isTrade: $isTrade) {
                currency
                displayName
                image
                url
            }
        }
    `,
    viewer: graphql`
        fragment SbRespPriceTiles_viewer on Viewer {
            ...SbRespTradeFreeShippingPromoTile_viewer
        }
    `,
});
